<mat-card class="password-reset-card">
  <mat-card-header>
    <mat-card-title class="password-reset-title">パスワードリセット手順</mat-card-title>
  </mat-card-header>
  <!-- <div class="errorMessage">{{errorMessage}}</div> -->
  <mat-card-content>
    <span>従来のURL認証によるパスワードリセット機能は廃止しました。下記手順を参考に対応をお願いします。</span>

    <h3>パスワードを変更したい場合</h3>
    <p>通常通りログインし、個人設定画面からパスワードを変更してください。<br />
      詳細な手順は運用マニュアルを参考にしてください。</p>

    <h3>パスワードを忘れた場合</h3>
    <p>人事室に仮パスワード発行依頼をお願いします。<br />
      仮パスワードを用いてログイン後、任意のパスワードに変更することができます。</p>

  </mat-card-content>
</mat-card>